import { __extends } from "tslib";
import { ASObject, GenericVector } from '@awayfl/avm2';
var LastOperationStatus = /** @class */ (function () {
    function LastOperationStatus() {
    }
    LastOperationStatus.BUFFER_OVERFLOW_ERROR = 'bufferOverflowError';
    LastOperationStatus.ERROR_CODE_UNKNOWN = 'errorCodeUnknown';
    LastOperationStatus.ILLEGAL_ARGUMENT_ERROR = 'illegalArgumentError';
    LastOperationStatus.INDEX_OUT_OF_BOUNDS_ERROR = 'indexOutOfBoundsError';
    LastOperationStatus.INVALID_ATTR_VALUE = 'invalidAttrValue';
    LastOperationStatus.INVALID_CHAR_FOUND = 'invalidCharFound';
    LastOperationStatus.MEMORY_ALLOCATION_ERROR = 'memoryAllocationError';
    LastOperationStatus.NO_ERROR = 'noError';
    LastOperationStatus.NUMBER_OVERFLOW_ERROR = 'numberOverflowError';
    LastOperationStatus.PARSE_ERROR = 'parseError';
    LastOperationStatus.PATTERN_SYNTAX_ERROR = 'patternSyntaxError';
    LastOperationStatus.PLATFORM_API_FAILED = 'platformAPIFailed';
    LastOperationStatus.TRUNCATED_CHAR_FOUND = 'truncatedCharFound';
    LastOperationStatus.UNEXPECTED_TOKEN = 'unexpectedToken';
    LastOperationStatus.UNSUPPORTED_ERROR = 'unsupportedError';
    LastOperationStatus.USING_DEFAULT_WARNING = 'usingDefaultWarning';
    LastOperationStatus.USING_FALLBACK_WARNING = 'usingFallbackWarning';
    return LastOperationStatus;
}());
export { LastOperationStatus };
var LocaleID = /** @class */ (function (_super) {
    __extends(LocaleID, _super);
    function LocaleID(_name) {
        var _this = _super.call(this) || this;
        _this._name = _name;
        _this.DEFAULT = 'i-default';
        _this._lastOperationStatus = LastOperationStatus.USING_DEFAULT_WARNING;
        return _this;
    }
    Object.defineProperty(LocaleID.prototype, "lastOperationStatus", {
        get: function () {
            return this._lastOperationStatus;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LocaleID.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LocaleID.prototype, "ctor", {
        get: function () {
            return LocaleID;
        },
        enumerable: true,
        configurable: true
    });
    LocaleID.determinePreferredLocales = function (want, have, keyword) {
        if (keyword === void 0) { keyword = 'userinterface'; }
        console.warn('[LocaleID] `determinePreferredLocales` not implemented');
        return new GenericVector();
    };
    LocaleID.prototype.getLanguage = function () {
        console.warn('[LocaleID] `getLanguage` not implemented, use default: en');
        this._lastOperationStatus = LastOperationStatus.NO_ERROR;
        return 'en';
    };
    LocaleID.prototype.getRegion = function () {
        console.warn('[LocaleID] `getRegion` not implemented, use default: UK');
        this._lastOperationStatus = LastOperationStatus.NO_ERROR;
        return 'UK';
    };
    LocaleID.prototype.getScript = function () {
        console.warn('[LocaleID] `getScript` not implemented, use default: \'\'');
        this._lastOperationStatus = LastOperationStatus.USING_DEFAULT_WARNING;
        return '';
    };
    LocaleID.prototype.getVariant = function () {
        console.warn('[LocaleID] `getVariant` not implemented, use default: \'\'');
        this._lastOperationStatus = LastOperationStatus.USING_DEFAULT_WARNING;
        return '';
    };
    LocaleID.prototype.isRightToLeft = function () {
        console.warn('[LocaleID] `isRightToLeft` not implemented, use default: true');
        return true;
    };
    LocaleID.prototype.getKeysAndValues = function () {
        console.warn('[LocaleID] `isRightToLeft` not implemented, use default: null');
        this._lastOperationStatus = LastOperationStatus.USING_DEFAULT_WARNING;
        return null;
    };
    return LocaleID;
}(ASObject));
export { LocaleID };
